// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-meet-3d-link-pair-header {\n  display: flex;\n  justify-content: space-between;\n}\n.ui-meet-3d-link-pair-header h3 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
